import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalf } from '@fortawesome/free-solid-svg-icons';

function Rating(props) {

    const starGen = () => {
        let ui = [];
        let isWholeNumber = props.number % 1 === 0 ? true : false;
        let wholeNumber = props.number / 1 - props.number % 1;
        for (let i = 0; i < wholeNumber; i++) {
            ui.push(<FontAwesomeIcon style={{ color: "#FEC030" }} icon={faStar} />);
        }
        if (!isWholeNumber) {
            ui.push(<FontAwesomeIcon style={{ color: "#FEC030" }} icon={faStarHalf} />);
            //increase wholeNumber bez half stare take full star place
            wholeNumber += 1;
        }
        for (let i = 0; i < 5 - wholeNumber; i++) {
            ui.push(<FontAwesomeIcon icon={faStar} />)
        }
        return ui;
    }
    return (
        <React.Fragment>
            {starGen()}
        </React.Fragment>);
}

export default Rating;